import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String, enabled: Boolean, lead: Number, tenantSlug: String };
  static targets = ["bell", "leadPicker"];

  #requestId = 0;

  connect() {
    this.#render();
  }

  toggle() {
    const requestId = ++this.#requestId;
    this.#patch({ enabled: !this.enabledValue }).then((d) => {
      if (requestId !== this.#requestId) return;
      this.enabledValue = d.enabled;
      this.#render();
    });
  }

  setLead(e) {
    const l = +e.params.lead;
    const requestId = ++this.#requestId;
    this.#patch({ lead_minutes: l }).then(() => {
      if (requestId !== this.#requestId) return;
      this.leadValue = l;
      this.#render();
    });
  }

  #render() {
    if (this.hasBellTarget) {
      this.bellTarget.classList.toggle("btn-primary", this.enabledValue);
      this.bellTarget.classList.toggle("btn-outline", !this.enabledValue);
    }
    if (this.hasLeadPickerTarget) {
      this.leadPickerTarget.classList.toggle("hidden", !this.enabledValue);
    }
  }

  async #patch(body) {
    const r = await fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.#csrfToken(),
      },
      body: JSON.stringify({ ...body, tenant_slug: this.tenantSlugValue }),
    });
    return r.json();
  }

  #csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || "";
  }
}
